export function setSpaceToDash(val: string, operator: string = '-') {
  if (!val)
    return

  return val?.toString().replace(/\s+/g, operator).toLowerCase()
}
export function handleToTop() {
  if (window && typeof window !== 'undefined')
    window.scrollTo({ top: 0, behavior: 'smooth' })
}
export function isValidUrl(urlString: string | undefined) {
  if (!urlString)
    return false
  const urlPattern = new RegExp('^(https?:\\/\\/)?' // validate protocol
  + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // validate domain name
  + '((\\d{1,3}\\.){3}\\d{1,3}))' // validate OR ip (v4) address
  + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // validate port and path
  + '(\\?[;&a-z\\d%_.~+=-]*)?' // validate query string
  + '(\\#[-a-z\\d_]*)?$', 'i') // validate fragment locator
  return !!urlPattern.test(urlString)
}

export function convertHex(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  /**
   * NOTE:
   * return as string with comma separated | R, G, B
   */
  const tmp = result
    ? `${Number.parseInt(result[1], 16)}, ${Number.parseInt(result[2], 16)}, ${Number.parseInt(result[3], 16)}`
    : null
  return tmp
}

export function n2lbr(str: string) {
  if (str)
    return str.replace(/\n/g, '<br/>')
}

export function handleMenuBottom(val: string) {
  const arr = ['privacy-policy', 'term-n-condition', 'payment-methods']
  const tmp = val
  const result: {
    title: string
    slug: string
  }[] = []
  if (tmp && tmp.length) {
    for (let i = 0; i < tmp.length; i++) {
      const el: any = tmp[i]
      if (i > 0 && i !== tmp.length - 1) {
        result.push({
          title: 'dots',
          slug: '',
        })
      }
      if (el && el?.slug && arr.findIndex(str => str.toLowerCase() === el?.slug.toLowerCase()) > -1)
        result.push(el)
    }
  }
  return result
}

interface IClearContent { str: string; escape_html?: boolean }
export function clearContent(props: IClearContent | string, defaultValue?: string) {
  if (!props || (typeof props === 'object' && props?.str === undefined))
    return defaultValue || ''

  if (typeof props === 'object') {
    const { str, escape_html = true } = props
    return str
      ? escape_html
        ? str
          .replace(/\&nbsp;/g, '')
          .replace(/\&amp;/g, '&')
          .replace(/<\/?[^>]+(>|$)/g, '')
          .replace(/(?:\r\n|\r|\n)/g, '<br/>')
        : str
          .replace(/(?:\r\n|\r|\n)/g, '<br/>')
      : null
  }
  else {
    return props
      .replace(/\&nbsp;/g, '')
      .replace(/\&amp;/g, '&')
      .replace(/<\/?[^>]+(>|$)/g, '')
      .replace(/(?:\r\n|\r|\n)/g, '<br/><br/>')
  }
}

export function removeBearerText(jwt: string) {
  return jwt.replace(/Bearer /g, '')
}

/**
 * Reorder the array of menu items so that the "contact-us" item is always last.
 */
interface MenuItem {
  slug: string
  title: string
  page_title: string
  is_navbar: number | boolean
  is_footer: number | boolean
  is_spa: number | boolean
  child?: string
}

export function reorderArrayWithContactUsLast(array: Array<MenuItem>): Array<MenuItem> {
  // Separate the "contact-us" item from the rest
  if (Array.isArray(array)) {
    const careerItem = array.find(item => item.slug === 'career')
    const contactUsItem = array.find(item => item.slug === 'contact-us')
    const otherItems = array.filter(item => item.slug && !['contact-us', 'career'].includes(item.slug))
    // Return the reordered array
    if (careerItem && Object.keys(careerItem).length)
      otherItems.push(careerItem)
    if (contactUsItem && Object.keys(contactUsItem).length)
      otherItems.push(contactUsItem)
    return otherItems
  }
  return array
}
